export const OKAY = 200;
export const I_AM_A_TEAPOT = 418;
export const BAD_SERVER = 500;
export const SERVICE_URL = window.config.WEB_API_URL;


// -------------------------------------
// Vehicle Registration Status
// store/modules/vehicle
// -------------------------------------
export const VEHICLE_MODULE = 'vehicle';
// getters
export const VEHICLE_LOOKUP_INFO = `${VEHICLE_MODULE}/lookupInfo`;
export const VEHICLE_STATUS_INFO = `${VEHICLE_MODULE}/statusInfo`;
// actions
export const VEHICLE_GET_TYPE_LIST = `${VEHICLE_MODULE}/getTypeList`;
export const VEHICLE_SET_DATA = `${VEHICLE_MODULE}/setVehicleData`;


// -------------------------------------
// Registration Fee Estimate
// store/modules/quote
// -------------------------------------
export const QUOTE_MODULE = 'quote';
// getters
export const QUOTE_LOOKUP_INFO = `${QUOTE_MODULE}/lookupInfo`;
export const QUOTE_ESTIMATE_INFO = `${QUOTE_MODULE}/estimateInfo`;
// actions
export const QUOTE_GET_TYPES = `${QUOTE_MODULE}/getVehicleAndPlateTypes`;
export const QUOTE_GET_ESTIMATE = `${QUOTE_MODULE}/getEstimate`;
export const QUOTE_SET_DATA = `${QUOTE_MODULE}/setQuoteData`;

// -------------------------------------
// Online Customer Account Login
// store/modules/guest
// -------------------------------------
export const GUEST_LOGIN_MODULE = 'guestLogin';

// getters
export const GUEST_LOGIN_LOOKUP_INFO = `${GUEST_LOGIN_MODULE}/lookupInfo`;
export const GUEST_LOGIN_STATUS_INFO = `${GUEST_LOGIN_MODULE}/statusInfo`;
// actions
export const GUEST_LOGIN_GET_LOGIN = `${GUEST_LOGIN_MODULE}/getGuestLogin`;
export const GUEST_LOGIN_SET_DATA = `${GUEST_LOGIN_MODULE}/setGuestLoginData`;

export const GUEST_LOGIN_GET_LOGIN_REQUEST = `${GUEST_LOGIN_MODULE}/getGuestLoginRequest`;

export const GUEST_LOGIN_GET_LOGIN_MFA_REQUEST = `${GUEST_LOGIN_MODULE}/getGuestLoginMfaRequest`;

export const GUEST_PROFILE = `${GUEST_LOGIN_MODULE}/getPersonalProfileInformation`;
export const GUEST_REGISTRATION = `${GUEST_LOGIN_MODULE}/getRegistrationInformation`;
export const GUEST_RENEWREGISTRATION = `${GUEST_LOGIN_MODULE}/getRenewRegistrationEligibility`;
export const GUEST_SELECTRENEWREGISTRATION = `${GUEST_LOGIN_MODULE}/getSelectRenewReg`;
export const GUEST_CREATETRANSACTION = `${GUEST_LOGIN_MODULE}/getCreateTransactionService`;
export const GUEST_SAVEWIPDATA = `${GUEST_LOGIN_MODULE}/getSaveWipData`;
export const GUEST_REGISTRATION_RENEWAL_FEE = `${GUEST_LOGIN_MODULE}/getRegistrationRenewalFee`;
export const GUEST_REMOVETRANSACTION = `${GUEST_LOGIN_MODULE}/getRemoveTransaction`
export const GUEST_ADDTRANSACTION = `${GUEST_LOGIN_MODULE}/getAddTransaction`;
export const GUEST_SERVICEFEES = `${GUEST_LOGIN_MODULE}/getServiceFees`;
export const GUEST_UPDATETRANSACTIONCART = `${GUEST_LOGIN_MODULE}/getUpdateTransactionCart`;
export const GUEST_RENEWPREVIOUSSTEP = `${GUEST_LOGIN_MODULE}/getRenewPreviousStep`;
export const GUEST_PAYMENTPROCESS = `${GUEST_LOGIN_MODULE}/getPaymentProcess`;
export const GUEST_FINALIZECART = `${GUEST_LOGIN_MODULE}/getFinalizecart`;
export const GUEST_SENDTRANSACTIONCONFIRMATION = `${GUEST_LOGIN_MODULE}/getSendTransactionConfiramtion`;
export const GUEST_VALIDATECART = `${GUEST_LOGIN_MODULE}/getValidatecart`;
export const GUEST_SELECTDUPLICATEREGISTRATION = `${GUEST_LOGIN_MODULE}/getSelectDuplicateReg`;

export const GUEST_DUPLICATEREGISTRATION = `${GUEST_LOGIN_MODULE}/getDuplicateRegistrationEligibility`;

export const GUEST_CANCELTRANSACTION = `${GUEST_LOGIN_MODULE}/getCancelTransaction`;


export const GUEST_CANCELREGISTRATION = `${GUEST_LOGIN_MODULE}/getCancelRegistrationEligibility`;

// getters
export const GUEST_PERSONAL_INFO = `${GUEST_LOGIN_MODULE}/personalInfo`;
export const GUEST_REGISTRATION_INFO = `${GUEST_LOGIN_MODULE}/registrationInfo`;
export const GUEST_REGISTRATION_INFO_ERROR = `${GUEST_LOGIN_MODULE}/errorMessageRegistration`;
export const GUEST_RENEWREGISTRATION_INFO = `${GUEST_LOGIN_MODULE}/renewRegistrationInfo`;
export const GUEST_CREATE_TRANSACTION_INFO = `${GUEST_LOGIN_MODULE}/createTransactionInfo`;
export const GUEST_SAVE_WIP_INFO = `${GUEST_LOGIN_MODULE}/saveWipDataInfo`;
export const GUEST_RENEWREGISTRATIONFEE_INFO = `${GUEST_LOGIN_MODULE}/renewRegistrationFeeInfo`;


export const GUEST_OUTPUT_DOCUMENT_INFO = `${GUEST_LOGIN_MODULE}/outputDocumentInfo`;

export const GUEST_ADDRESS_LOOKUP_INFO = `${GUEST_LOGIN_MODULE}/addressLookupInfo`;

//actions
export const GUEST_LOGIN_GET_LOGOUT = `${GUEST_LOGIN_MODULE}/getGuestLogout`;

//actions
export const GUEST_LOGIN_EXTEND_LOGIN = `${GUEST_LOGIN_MODULE}/getExtendGuestLogin`;

//action
export const GUEST_ADJUDICATION = `${GUEST_LOGIN_MODULE}/getAdjudicationInformation`;

export const GUEST_OUTPUT_DOCUMENT = `${GUEST_LOGIN_MODULE}/getOutputDocumentInformation`;
// getters
export const GUEST_ADJUDICATION_LICENSE_INFO = `${GUEST_LOGIN_MODULE}/adjudicationLicenseInfo`;
export const GUEST_ADJUDICATION_COMMERCIAL_LICENSE_INFO = `${GUEST_LOGIN_MODULE}/adjudicationCommercialLicenseInfo`;
export const GUEST_ADJUDICATION_REGISTRATION_INFO = `${GUEST_LOGIN_MODULE}/adjudicationRegistrationInfo`;
// actions
export const GUEST_CRASH_LOCATION = `${GUEST_LOGIN_MODULE}/getCrashLocation`;

export const GUEST_UPDATE_CONTACT = `${GUEST_LOGIN_MODULE}/getUpdateContact`;

export const GUEST_SEND_MFA_REQUEST = `${GUEST_LOGIN_MODULE}/getGuestSendMfaRequest`;

export const GUEST_VERIFY_MFA_REQUEST = `${GUEST_LOGIN_MODULE}/getGuestVerifyMfa`;

export const GUEST_UPDATE_ADDRESS = `${GUEST_LOGIN_MODULE}/getUpdateAddress`;

export const GUEST_CONFIRM_ADDRESS = `${GUEST_LOGIN_MODULE}/postConfirmAddress`;

export const GUEST_US_STATES = `${GUEST_LOGIN_MODULE}/getUsStates`;

export const GUEST_INSTATE_ZIPCODES = `${GUEST_LOGIN_MODULE}/getInstateZipCodes`;